import { defineStore } from "pinia";
import Services from '@/services/deceasedServices'
import { mapDeceased } from '@/helpers/mapFuncs'
import { assertPersonType } from '@/helpers/personTypeGuard'

export const useDeceasedStore = defineStore("deceased", {

state:()=>({
    deceased: {},
    deceaseds: [],
}),
getters : {
    getDeceased() {
        return mapDeceased(this.deceased)
    },
    getDeceaseds() {
        return this.deceaseds.map(mapDeceased)
    }
},
actions : {
    /** Start Sets */
    setDeceased(deceased) {
        this.deceased = deceased
    },
    setDeceaseds(deceaseds) {
        this.deceaseds = deceaseds
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setDeceased(response.data.data)
            return response
        })
    },
    getFamilyByPersonId(id) {
        return Services.getFamilyByPersonId(id)
        .then((response)=>{
            let data = response.data.data.sacrificer;
            data.members = response.data.data.member;
            this.setDeceased(data)
            return response
        })
    },
    getProfileDataByPersonId(id) {
        return Services.getProfileDataByPersonId(id)
        .then((response)=>{
            let data = { ...response.data.data.dead , ...response.data.data, members: response.data.data.familyMembers };
            assertPersonType(data, 3)
            this.setDeceased(data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setDeceaseds(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.deceaseds.push(response.data.data)
            return mapDeceased(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.deceaseds[this.deceaseds.findIndex((x)=>x.id == id)] = response.data.data?.person
            return mapDeceased(response.data.data?.person)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.deceaseds = this.deceaseds.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});